import { adminHttpClient } from '../../commons/adminHttpClient'

export interface ProgramDetailsDto extends GeneralDetails {
  groupHealthPlan: GroupHealthPlanDetails
}

export interface GeneralDetails {
  name: string
  ein: string
  taxClassification: string
  mainPhoneNumber: string
  primaryAdmin: string
  primaryAdminEmail: string
  primaryAdminPhoneNumber: string
}

export interface GroupHealthPlanDetails {
  startDate: string
  insuranceCarrier: string
  insurancePlan: string
  waitingPeriod: 0
}

const getProgramDetails = (companyId: string, planPeriodId: string): Promise<ProgramDetailsDto> => {
  return adminHttpClient.get(`/csi/Companies/generaldetailswithgrouphealthplan/${companyId}/${planPeriodId}`)
}

export default getProgramDetails
